import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const documentViewPropType = PropTypes.shape({
    data: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    isError: PropTypes.bool,
}).isRequired;
